.root {
  display: flex;
}

.root:not(.compact) {
  gap: var(--spacingSm);

  > * {
    &:first-child {
      border-radius: 20px 6px 6px 20px;
    }

    &:last-child {
      border-radius: 6px 20px 20px 6px;
    }

    &:not(:first-child, :last-child) {
      border-radius: 6px;
    }
  }
}

.root.compact {
  > * {
    border-right: 1px solid var(--paletteTrans2);

    &:first-child {
      border-top-right-radius: 0;
      border-bottom-right-radius: 0;
    }

    &:not(:first-child, :last-child) {
      border-radius: 0;
    }

    &:last-child {
      border-top-left-radius: 0;
      border-bottom-left-radius: 0;
      border-right: 0;
    }
  }
}

@media (max-width: 550px) {
  .mobileBreak > * {
    display: block;
    width: 100%;
    margin: 0 0 5px !important;
    border-radius: var(--radiusSm) !important;
  }
}
